import React from "react";
import "@/index.css";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import OnboardingPage from "@/pages/OnboardingPage";
import GamePage from "@/pages/GamePage";
import ResultPage from "@/pages/ResultPage";
import LeaderboardPage from "@/pages/LeaderboardPage";
import ProfilePage from "@/pages/ProfilePage";
import AuthCallback from "@/pages/AuthCallback";
import ChallengePage from "@/pages/ChallengePage";
import ProSuccessPage from "@/pages/ProSuccessPage";
import AdminPage from "@/pages/AdminPage";
import ProtectedRoute from "@/components/ProtectedRoute";
import AdminRoute from "@/components/AdminRoute";
import DailyEntryPage from "@/pages/DailyEntryPage";
import SeoPlayPage from "@/pages/SeoPlayPage";
import SupportButton from "@/components/SupportButton";

function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<OnboardingPage />} />
      <Route path="/play/debates/:slug" element={<SeoPlayPage />} />
      <Route path="/daily" element={<DailyEntryPage />} />
      <Route path="/demo" element={<GamePage demoMode />} />
      <Route path="/demo/result/:debateId" element={<ResultPage demoMode />} />
      <Route
        path="/game"
        element={
          <ProtectedRoute>
            <GamePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/result/:debateId"
        element={
          <ProtectedRoute>
            <ResultPage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/profile"
        element={
          <ProtectedRoute>
            <ProfilePage />
          </ProtectedRoute>
        }
      />
      <Route
        path="/admin"
        element={
          <AdminRoute>
            <AdminPage />
          </AdminRoute>
        }
      />
      <Route path="/leaderboard" element={<LeaderboardPage />} />
      <Route path="/challenge/:challengeId" element={<ChallengePage />} />
      <Route
        path="/pro/success"
        element={
          <ProtectedRoute>
            <ProSuccessPage />
          </ProtectedRoute>
        }
      />
      <Route path="/pro/failure" element={<Navigate to="/game" replace />} />
      <Route path="/pro/pending" element={<Navigate to="/game" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-[#FFFDF5] text-[#101010]">
      <BrowserRouter>
        <AppRouter />
        <SupportButton />
        <Toaster
          position="top-center"
          toastOptions={{
            style: {
              border: "3px solid #101010",
              borderRadius: "12px",
              boxShadow: "6px 6px 0px 0px rgba(16,16,16,1)",
              fontWeight: 700,
              background: "#FFDE59",
              color: "#101010",
            },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
